import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

// Elements
import Showcase from 'components/elements/Showcase'
import ButtonDefault from 'components/elements/ButtonDefault'

// Third Party
import styled from 'styled-components'

const StyledOtherShowcases = styled.div`
  background-color: rgba(16,16,16,0.1);
`

const OtherShowcases = ({ className, id }) => {
  const {
    showcases: {
      nodes: showcases
    }
  } = useStaticQuery(graphql`{
    showcases: allWordpressWpShowcase {
      nodes {
        ...ShowcasePreviewFrag
      }
    }
  }`)

  const filteredShowcases = showcases.filter((s) => s.wordpress_id !== id).slice(0, 2)

  return (
    <StyledOtherShowcases className={`${className ? `${className}` : ``}`}>
      <div className="container py-5">
        <h2 className="font-family-secondary text-center mb-4 font-size-xxl">ANDERE PRODUCTEN</h2>
        <div className="row">
          {filteredShowcases.map(s => (
            <div key={s.wordpress_id} className="col-lg-6">
              <Showcase black showcase={s} />
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-center py-lg-5 py-3">
          <ButtonDefault to="/showcase">
            <p className="mb-0">Bekijk alle producten</p>
          </ButtonDefault>
        </div>
      </div>
    </StyledOtherShowcases>
  
  )
}

export default OtherShowcases